import type { Variants } from 'motion/react'
import { motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { Text } from 'ui/src/components/Text/Text'
import { yStack } from 'ui/src/patterns/stack'
import { fill, track } from './PriceLoader.css'

const ANIMATION_DURATION_SEC = 2

const VARIANTS: Variants = {
  enter: {
    width: '0%',
  },
  animate: {
    width: '100%',
    transition: {
      delay: 0,
      // Account for delay in mounting the component
      duration: ANIMATION_DURATION_SEC * 0.8,
      ease: 'easeInOut',
    },
  },
}

export function PriceLoader() {
  const { t } = useTranslation('purchase-form')

  return (
    <div className={yStack({ gap: 'lg' })}>
      <Text size="md" align="center">
        {t('LOADING_PRICE_ANIMATION_LABEL')}
      </Text>
      <div className={track}>
        <motion.div className={fill} variants={VARIANTS} initial="enter" animate="animate" exit="enter" />
      </div>
    </div>
  )
}

export const completePriceLoader = () =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve()
    }, ANIMATION_DURATION_SEC * 1000)
  })
